import Decimal from 'decimal.js';

/**
 * Kriptovaluták egységes formázása adott tizedesjegyig.
 * @param value A formázandó érték (string vagy number)
 * @param decimals A tizedesjegyek száma (alapértelmezetten 8)
 * @returns A formázott string
 */
export const formatCrypto = (value: any, decimals: number = 8): string => {
    if (!value || new Decimal(value).isZero()) {
        // Ha fix nullákat is akarsz a végén (pl. "0.00000000"), cseréld a '0'-t erre: 
        // return Number(0).toFixed(decimals);
        return '0.00000000'; 
    }
    
    // Ha levágnád a felesleges nullákat: .toDecimalPlaces(decimals).toString()
    // Ha fixen ki akarod írni az összes nullát: .toFixed(decimals)
    return new Decimal(value).toFixed(decimals); 
};